export enum OrganizationBranchesAPI {
    getOrganizationBranch = "OrganizationBranches.GetOrganizationBranch",
    getOrganizationBranches = "OrganizationBranches.GetOrganizationBranches",
    updateOrganizationBranch = "OrganizationBranches.UpdateOrganizationBranch",
    getPaymentProviderDetailsPublic = "OrganizationBranches.GetPaymentProviderDetailsPublic",
    getServicePaymentProviderDetails = "OrganizationBranches.GetServicePaymentProviderDetails",
    updateCompanyCard = "OrganizationBranches.UpdateCompanyCard",
    createServiceOrder = "ServiceOrders.CreateServiceOrder"
}
